import { defaultParamsSerializer } from '../../internals'

import { HttpModel } from './httpModel.class'

/**
 * @documentation https://recherche-entreprises.api.gouv.fr/docs/#tag/Recherche-textuelle/paths/~1search/get
 */
export class HttpGouv extends HttpModel {
  constructor() {
    super(
      {
        baseURL: 'https://recherche-entreprises.api.gouv.fr',
        paramsSerializer: defaultParamsSerializer
      },
      HttpModel.contentTypes.json
    )
  }
}

export const httpGouv = new HttpGouv()
